import React, { FC } from 'react';
import styled from '@emotion/styled';
import { MultiplierStyleProps } from '..';
import { useStorage } from '~Components/Storage';
import { GetOrder_order } from '~Queries/__queries__';
import { ThirdPartyMetadata } from '../utils';
import { Order } from '@baemingo/order-status-events/dist/types';

const OriginWrapper = styled.div<MultiplierStyleProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  background-color: var(--colorBlueGray100);
  padding: ${({ styleMultiplier }) =>
    `calc(12px - 0.2em * ${styleMultiplier?.space}) calc(16px - 0.2em * ${styleMultiplier?.space})`};
  color: var(--colorBlueGray800);
  font-size: calc(16px - 0.1em * ${({ styleMultiplier }) => styleMultiplier?.size});
  line-height: calc(24px - 0.2 * ${({ styleMultiplier }) => styleMultiplier?.size});
  letter-spacing: 0.24px;
  font-weight: 600;
  align-items: center;
  justify-content: space-between;
  border-top: 4px solid var(--colorBlueGray200);
`;

interface Props {
  thirdPartyMetadata?: ThirdPartyMetadata | null;
  realOrder?: GetOrder_order | null;
  order: Order;
}

/**
 * Component displayed in the bottom of an KDS order
 * Content differ based on origin
 * - For THIRD_PARTY origin: Display the customer name and phone number + the channelName (like Uber Eats for instance)
 * - For the other origins: Display the user name (if it exists) and the origin (like POS or App)
 */
const Origin: FC<Props> = ({ thirdPartyMetadata, realOrder, order }) => {
  const [storage] = useStorage();

  const getUserInfoString = () => {
    /* THIRD_PARTY Example: John Smith (+46 XX XXX XX XX) */
    if (thirdPartyMetadata?.customer) {
      return thirdPartyMetadata.customer.phoneNumber
        ? `${thirdPartyMetadata.customer.name} (${thirdPartyMetadata.customer.phoneNumber})`
        : thirdPartyMetadata.customer.name;
    }

    // Default case
    return realOrder?.user ? realOrder?.user.name : '';
  };

  const getOriginInfoString = () => {
    /* For THIRD_PARTY we display the channelName (like Uber Eays) instead of the ORDER_ORIGIN */
    if (thirdPartyMetadata?.channelName) {
      return thirdPartyMetadata.channelName;
    }

    // Default case
    return realOrder ? realOrder.origin : order.origin || 'POS';
  };

  const userInfo = getUserInfoString();
  const originInfo = getOriginInfoString();

  return (
    <OriginWrapper styleMultiplier={storage.styleMultiplier}>
      <span>{userInfo}</span>
      <span>{originInfo}</span>
    </OriginWrapper>
  );
};

export default Origin;
